import { render, staticRenderFns } from "./initiate.vue?vue&type=template&id=0236c656&scoped=true&"
import script from "./initiate.vue?vue&type=script&lang=js&"
export * from "./initiate.vue?vue&type=script&lang=js&"
import style0 from "./initiate.vue?vue&type=style&index=0&id=0236c656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236c656",
  null
  
)

export default component.exports